import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutResetFileNumber extends Layout {
    sourceEftFileNum: DataSource;
}
